import { useEffect, useState } from 'react';

export type PlanGuidePopoverConfig = {
  error?: string;
  dismissedPlanGuide: boolean;
};

interface UsePlanGuidePopoverProps {
  errorConfig: PlanGuidePopoverConfig;
}

export default function usePlanGuidePopover({ errorConfig }: UsePlanGuidePopoverProps) {
  const [showPopover, setShowPopover] = useState(false);
  const [error, setError] = useState<string | undefined>(errorConfig.error);

  useEffect(() => {
    if (errorConfig.error) {
      setError(errorConfig.error);
    } else {
      // Delay clearing the error so that if a user picks a plan to dismiss the plan guide, the error message still shows while the popover is animating out.
      // The delay time should match the animation duration of the popover when it closes in PlanGuidePopover.
      const timeout = setTimeout(() => {
        setError(undefined);
      }, 1000); // match duration css animation in guide-popover.tsx

      return () => clearTimeout(timeout);
    }
  }, [errorConfig.error]);

  useEffect(() => {
    if (errorConfig.error && !errorConfig.dismissedPlanGuide) {
      setShowPopover(true);
    } else {
      setShowPopover(false);
    }
  }, [errorConfig.error, errorConfig.dismissedPlanGuide]);

  return {
    showPopover,
    error,
  };
}
